import { createSelector } from 'reselect'

import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectIsBusinessPrioritiesFetching = createSelector(
  [selectBusinessPrioritiesState],
  (state) => state.isLoading
)
